const namespace = "potba";

import AppConfig from "@/_config/application-config";
import childRoutes from "./routes";
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  name: "POTBA",
  namespace,
  description: null,
  version: "1.0.0",
  icon: "mdi-gauge",
  accentColor: "#000080",
  mainNavEnabled: false,
  topBarEnabled: false,
  parentRoute: "/potba",
  defaultRoute: "home",
  childRoutes,
  component: () =>
    import(/* webpackChunkName: "potba-parent" */ "@/apps/potba/Application.vue"),
  settings: {
    environment: "DEV",
    //grantType: "client_credentials",
    scope: "api://2fee4891-cbfe-4152-9b04-8cbafd566f6f/Read.All",
    clientId: "2fee4891-cbfe-4152-9b04-8cbafd566f6f",
    apiUrl: "https://localhost:44339/api", 
    //apiUrl: "https://potbaapi-dev.lyondellbasell.com/api",
    //apiUrl: "https://api.lyb.com/external/potba/api",
    authorizeUrl:
    "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    redirect_uri: window.location.origin,
    logoutUrl:
    `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri==${window.location.origin}`,
    tokenUrl:
    "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",

    env_color_dev: { "r": 96, "g": 125, "b": 139, "a": 1 },
    env_color_stg: { "r": 38, "g": 166, "b": 154, "a": 1 },
    isAzureDeployed: true,
    //env_color:'"primary"', //PROD
    powerBiUrl: "",
    frmlink: "",
    appNavigation: [
       {
         icon: "mdi-home",
         text: "Home",
         link: "/potba/home"
       }
      ,
       {
         icon: "mdi-account-lock-outline",
         text: "Admin",
         link: "/potba/admin",
         roles: ["admin"],
         items: [
          {
            icon: "mdi-hammer-wrench",
            text: "Configuration",
            link: "/potba/configurations",
            roles: ["admin"]
          },
          {
            icon: "mdi-monitor-arrow-down",
            text: "PBI Data Import To Db",
            link: "/potba/PBIDataImportToDb",
            roles: ["admin"]
          },
          {
            icon: "mdi-chart-box-plus-outline",
            text: "PBI Configuration",
            link: "/potba/PBIConfigurations",
            roles: ["admin"]
          },
          {
            icon: "mdi-account-multiple-outline",
            text: "User Assignment",
            link: "/potba/userAssignment",
            roles: ["admin"]
          },
        ],
       },
    ],
  },

  store: {
    pageTitle: {
      default: "potba",
      storageMode: localStorage,
    },
    userDetails: {
      default: null,
      storageMode: sessionStorage,
    },
    impersonationDetails: {
      default: null,
      storageMode: sessionStorage,
    },
    credentialCache: {
      default: {},
      storageMode: sessionStorage,
    },
    userRoles: {
      default: [],
      storageMode: sessionStorage,
    },
    navItems: {
      default: [],
      storageMode: sessionStorage,
    }
  },
  
};

export default AppConfig.merge(appConfig);
